var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.28666 19.7087C0.680653 20.0915 1.31901 20.0915 1.70681 19.7087L9.99517 11.4041L18.2998 19.7087C18.6713 20.0915 19.3209 20.0915 19.7087 19.7087C20.0915 19.3097 20.0915 18.6713 19.7087 18.2947L11.4041 9.99518L19.7087 1.70681C20.0915 1.31901 20.1027 0.669443 19.7087 0.286664C19.3097 -0.0899274 18.6713 -0.0899274 18.2998 0.286664L9.99517 8.58624L1.70681 0.286664C1.31901 -0.0899274 0.66944 -0.101141 0.28666 0.286664C-0.0899278 0.680657 -0.0899278 1.31901 0.28666 1.70681L8.58623 9.99518L0.28666 18.2947C-0.0899278 18.6713 -0.101138 19.3209 0.28666 19.7087Z",
    fill: "#181E3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.400d339257021dfb4d0f831d1280d5af.svg";
export { ForwardRef as ReactComponent };